import React, { useState } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import 'moment/locale/th';

import { useTranslation } from 'react-i18next';

// material-ui
import MaterialTable, { MTableToolbar } from 'material-table';
import Paper from '@material-ui/core/Paper';
import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Box from '@material-ui/core/Box';
import Button from '@material-ui/core/Button';
import Tooltip from '@material-ui/core/Tooltip';

// component
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChartLine } from '@fortawesome/free-solid-svg-icons';
import tableIcons from '../../../components/table/MaterialTableIcon';
import exportCsv from '../../../utils/export/Csv';
import WaterQualityStatusColor from '../map/WaterQualityStatusColor';
import { StyledIconButton } from '../../../components/button/Button';
import WaterQualityChart from '../chart/WaterQualityChart';
import Modal from '../../../components/modal/Modal';

// style
import { styles } from './style';

const useStyles = makeStyles(styles);
export default function WaterQualityLists(props) {
  const { t } = useTranslation();
  const classes = useStyles();
  const {
    datas,
    handleSearchMarker,
    currentMode,
    currentArea,
    userIsLogin,
  } = props;
  const [modalData, setModalData] = useState({
    open: false,
    header: '',
    subheader: null,
    content: null,
  });
  const [modalDataReset] = useState({
    open: false,
    header: '',
    subheader: null,
    content: null,
  });

  const isExport = (userIsLogin) ? { csv: true } : userIsLogin;

  const handleChart = (data) => (e) => {
    e.preventDefault();
    setModalData({
      open: true,
      header: t('เปรียบเทียบสถานีคุณภาพน้ำ'),
      subheader: null,
      content: <WaterQualityChart
        id={data.waterquality_station.id}
        provinceId={data.waterquality_station.province_code}
      />,
    });
  };

  function resetModal() {
    setModalData(modalDataReset);
    modalData.open = false;
  }

  function filterData(currentData, mode, area) {
    let filterD = [];
    if (mode === 'province' && area.code !== '0') {
      filterD = currentData.filter((d) => d.waterquality_station.province_code === area.code);
    } else if (currentMode === 'basin' && area.code !== '0') {
      filterD = currentData.filter((d) => d.basin.basin_code === parseInt(area.code, 10));
    } else {
      filterD = currentData;
    }

    return filterD;
  }

  function waterQualityStatusBadge(data, value, type) {
    if (type === 'ph') {
      const status = WaterQualityStatusColor(data, 'ph');
      const statusText = `
      <p
        className="${classes.status}"
        style=background:${status.color.statusColor};text-align:center;width:60px;margin-left:44%;color:${status.color.color};
      >
      ${Number(value).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
      </p>`;
      return typeof value === 'undefined' || value == null ? '-' : statusText;
    }
    if (type === 'salinity') {
      const status = WaterQualityStatusColor(data, 'salinity');
      const statusText = `
      <p
        className="${classes.status}"
        style=background:${status.color.statusColor};text-align:center;width:60px;margin-left:44%;color:${status.color.color};
      >
      ${Number(value).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
      </p>`;
      return typeof value === 'undefined' || value == null ? '-' : statusText;
    }
    if (type === 'turbid') {
      const status = WaterQualityStatusColor(data, 'turbid');
      const statusText = `
      <p
        className="${classes.status}"
        style=background:${status.color.statusColor};text-align:center;width:60px;margin-left:44%;color:${status.color.color};
      >
      ${Number(value).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
      </p>`;
      return typeof value === 'undefined' || value == null ? '-' : statusText;
    }
    if (type === 'tds') {
      const status = WaterQualityStatusColor(data, 'tds');
      const statusText = `
      <p
        className="${classes.status}"
        style=background:${status.color.statusColor};text-align:center;width:60px;margin-left:44%;color:${status.color.color};
      >
      ${Number(value).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
      </p>`;
      return typeof value === 'undefined' || value == null ? '-' : statusText;
    }
    if (type === 'do') {
      const status = WaterQualityStatusColor(data, 'do');
      const statusText = `
      <p
        className="${classes.status}"
        style=background:${status.color.statusColor};text-align:center;width:60px;margin-left:44%;color:${status.color.color};
      >
      ${Number(value).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
      </p>`;
      return typeof value === 'undefined' || value == null ? '-' : statusText;
    }
    return true;
  }

  return (
    <>
      <Paper className={classes.root}>
        <MaterialTable
          icons={tableIcons}
          data={filterData(datas, currentMode, currentArea)}
          columns={[
            {
              title: t('ชื่อสถานี'),
              title_export: t('ชื่อสถานี'),
              field: 'waterquality_station.waterquality_station_name.th',
              width: 230,
              headerStyle: {
                left: 0,
                position: 'sticky',
                zIndex: 50,
              },
              cellStyle: {
                left: 0,
                position: 'sticky',
                wordWrap: 'normal',
                textAlign: 'left',
                padding: '0em',
              },
              render: (rowData) => {
                if (
                  rowData.waterquality_station.waterquality_station_lat
                  && rowData.waterquality_station.waterquality_station_long
                ) {
                  // console.log('rowData ', rowData);
                  return (
                    <Box display="flex" style={{ backgroundColor: 'white' }}>
                      <Button
                        onClick={handleSearchMarker(
                          rowData.id,
                          rowData.waterquality_station.waterquality_station_lat,
                          rowData.waterquality_station.waterquality_station_long,
                        )}
                        title={`${rowData.waterquality_station.agency_name.th}\n${t('แสดงตำแหน่งบนแผนที่')}`}
                      >
                        {`${rowData.waterquality_station.waterquality_station_name.th}`}
                      </Button>
                    </Box>
                  );
                }
                return (
                  <Button
                    onClick={handleSearchMarker(
                      rowData.id,
                      rowData.waterquality_station.waterquality_station_lat,
                      rowData.waterquality_station.waterquality_station_long,
                    )}
                    title={t('แสดงตำแหน่งบนแผนที่')}
                  >
                    {`สถานี${rowData.waterquality_station.waterquality_station_name.th}`}
                  </Button>
                );
              },
            },
            {
              title: t('รหัสสถานี'),
              type: 'string',
              field: 'waterquality_station.waterquality_station_oldcode',
              hidden: true,
              export: false,
              searchable: true,
            },
            {
              title: t('ที่ตั้ง'),
              field: 'address',
              type: 'string',
              export: false,
              width: 230,
              render: (rowData) => {
                const tumbonNameTh = rowData.waterquality_station.tumbon_name.th;
                return (
                  <Box style={{ wordWrap: 'break-word' }}>
                    {
                      tumbonNameTh !== '' ? (
                        `${t('ต.')}${tumbonNameTh} ${t('อ.')}${rowData.waterquality_station.amphoe_name.th} ${t('จ.')}${rowData.waterquality_station.province_name.th}`
                      ) : (
                        `${t('อ.')}${rowData.waterquality_station.amphoe_name.th} ${t('จ.')}${rowData.waterquality_station.province_name.th}`
                      )
                    }
                  </Box>
                );
              },
            },
            {
              title: t('ตำบล'),
              title_export: t('ตำบล'),
              field: 'waterquality_station.tumbon_name.th',
              type: 'string',
              searchable: true,
              export: false,
              hidden: true,
            },
            {
              title: t('อำเภอ'),
              title_export: t('อำเภอ'),
              field: 'waterquality_station.amphoe_name.th',
              type: 'string',
              searchable: true,
              export: false,
              hidden: true,
            },
            {
              title: t('จังหวัด'),
              title_export: t('จังหวัด'),
              field: 'waterquality_station.province_name.th',
              type: 'string',
              hidden: true,
            },
            {
              title: t('แม่น้ำ'),
              title_export: t('แม่น้ำ'),
              field: 'waterquality_station.river_name',
              type: 'string',
              width: 150,
              hidden: !userIsLogin,
              render: (rowData) => rowData.waterquality_station.river_name,
            },
            {
              title: t('เวลา'),
              title_export: t('เวลา'),
              field: 'waterquality_datetime',
              type: 'date',
              width: 115,
              render: (rowData) => `${moment(rowData.waterquality_datetime).locale('th').format('LT')} น.`,
            },
            {
              title: t('กรดด่าง'),
              title_export: t('กรดด่าง'),
              field: 'waterquality_ph',
              type: 'numeric',
              sorting: true,
              width: 115,
              render: (rowData) => {
                const WqPh = waterQualityStatusBadge(
                  rowData.waterquality_ph,
                  rowData.waterquality_ph,
                  'ph',
                );
                return <Box style={{ padding: 0 }} dangerouslySetInnerHTML={{ __html: WqPh }} />;
              },
            },
            {
              title: t('ความเค็ม'),
              title_export: t('ความเค็ม'),
              field: 'waterquality_salinity',
              type: 'numeric',
              sorting: true,
              width: 115,
              render: (rowData) => {
                const WqSalinity = waterQualityStatusBadge(
                  rowData.waterquality_salinity,
                  rowData.waterquality_salinity,
                  'salinity',
                );
                return (
                  <Box style={{ padding: 0 }} dangerouslySetInnerHTML={{ __html: WqSalinity }} />
                );
              },
            },
            {
              title: t('ความขุ่น'),
              title_export: t('ความขุ่น'),
              field: 'waterquality_turbid',
              type: 'numeric',
              sorting: true,
              width: 115,
              render: (rowData) => {
                const WqTurbid = waterQualityStatusBadge(
                  rowData.waterquality_turbid,
                  rowData.waterquality_turbid,
                  'turbid',
                );
                return (
                  <Box style={{ padding: 0 }} dangerouslySetInnerHTML={{ __html: WqTurbid }} />
                );
              },
            },
            {
              title: t('สารละลาย'),
              title_export: t('สารละลาย'),
              field: 'waterquality_tds',
              type: 'numeric',
              sorting: true,
              width: 115,
              render: (rowData) => {
                const WqTurbid = waterQualityStatusBadge(
                  rowData.waterquality_tds,
                  rowData.waterquality_tds,
                  'tds',
                );
                return (
                  <Box style={{ padding: 0 }} dangerouslySetInnerHTML={{ __html: WqTurbid }} />
                );
              },
            },
            {
              title: t('ออกซิเจน'),
              title_export: t('ออกซิเจน'),
              field: 'waterquality_do',
              type: 'numeric',
              sorting: true,
              width: 115,
              render: (rowData) => {
                const WqDo = waterQualityStatusBadge(
                  rowData.waterquality_do,
                  rowData.waterquality_do,
                  'do',
                );
                return (
                  <Box style={{ padding: 0 }} dangerouslySetInnerHTML={{ __html: WqDo }} />
                );
              },
            },
            {
              field: 'graph',
              type: 'numeric',
              sorting: false,
              width: 115,
              render: (rowData) => (
                <>
                  <Tooltip title={t('คลิ๊กเพื่อแสดงกราฟคุณภาพน้ำ')}>
                    <StyledIconButton onClick={handleChart(rowData)}>
                      <FontAwesomeIcon icon={faChartLine} fontSize="small" style={{ padding: 0, color: '#888' }} />
                    </StyledIconButton>
                  </Tooltip>
                </>
              ),
            },
          ]}
          localization={{
            body: { emptyDataSourceMessage: datas.length === 0 ? <h3>{t('กำลังโหลดข้อมูล...')}</h3> : <h3>{t('ไม่มีข้อมูลตามเงื่อนไข')}</h3> },
            toolbar: {
              searchPlaceholder: t('ค้นหา'),
              exportTitle: t('ดาวน์โหลดข้อมูลคุณภาพน้ำ'),
            },
            pagination: {
              labelRowsSelect: t('แถว'),
            },
          }}
          options={{
            // tableLayout: 'fixed',
            pageSize: 10,
            sorting: true,
            // searchFieldStyle: {
            //   alignSelf: { sm: 'center', md: 'flex-end' },
            // },
            rowStyle: {
              wordWrap: 'break-word',
            },
            toolbar: true,
            showTitle: false,
            search: true,
            exportButton: isExport,
            exportCsv,
            cellStyle: {
              padding: 8,
            },
          }}
          components={{
            Toolbar: (props) => (
              <Box mx={2}>
                <Grid container direction="row" alignItems="center" justifyContent="flex-end" spacing={2}>
                  <Grid item xs={12} sm={8} md={6}>
                    <MTableToolbar {...props} />
                  </Grid>
                </Grid>
              </Box>
            ),
          }}
        />
        <Modal
          open={modalData.open}
          modalHeader={modalData.header}
          modalSubHeader={modalData.subheader}
          modalContent={modalData.content}
          resetModal={resetModal}
        />
      </Paper>
    </>
  );
}

WaterQualityLists.propTypes = {
  datas: PropTypes.instanceOf(Array).isRequired,
  handleSearchMarker: PropTypes.func.isRequired,
  currentMode: PropTypes.string.isRequired,
  currentArea: PropTypes.instanceOf(Object).isRequired,
  userIsLogin: PropTypes.bool.isRequired,
};
